import React from "react";
import styled from "styled-components";
import { Tag } from 'antd';
import { Card } from 'antd';
import "antd/dist/antd.css";

import { useStore } from 'react-context-hook'

const TagWrapper = styled.div`

`;

const StyledTag = styled(Tag)`
    margin: 2px;
`;

const PlayerInfo = ({ player }) => {

    const [gameState] = useStore('game', {});

    const currentPlayer = gameState.currentPlayer === player;
    const calledTichu = gameState.tichus[player];
    const calledGradTichu = gameState.grandTichus[player];
    const trickWinner = gameState.trickWinner === player;
    return (
        <TagWrapper>
            <Card
                size="small" title={"Player " + player}
                extra={trickWinner && <StyledTag color="gold">Trick Winner</StyledTag>}
                headStyle={{ 'backgroundColor': currentPlayer ? '#b4ff98' : '#FFFFFF'}}
                style={{ width: 200 }}
            >
                {calledTichu && <StyledTag color="cyan">Tichu</StyledTag>}
                {calledGradTichu && <StyledTag color="blue">Grand Tichu</StyledTag>}
            </Card>
        </TagWrapper>
    );
};

export default PlayerInfo;